module.exports = __webpack_public_path__ + "img/job_bg.eb9bdaa5.jpg";